<script setup lang="ts">
import { EDIT_SCOPES, type EditScope } from '@/constants/editScope'

const scope = defineModel<EditScope>({ required: true })

defineProps<{
  chartAvailable: boolean
}>()
</script>

<template>
  <div class="mb-4">
    <div class="text-subtitle-2 mb-1">Apply changes to</div>
    <v-radio-group v-model="scope" inline hide-details density="compact">
      <v-radio label="All graphs" :value="EDIT_SCOPES.ALL" />
      <v-radio label="This graph only" :value="EDIT_SCOPES.CHART" :disabled="!chartAvailable" />
    </v-radio-group>
    <div class="text-caption text-medium-emphasis mt-1">
      <strong>All graphs</strong> updates the material everywhere and clears graph-specific
      overrides. <strong>This graph only</strong> changes just the current chart.
    </div>
  </div>
</template>
